const CustomClassifyStatistics = () =>
  import('@/views/main/wechatMgmt/customClassifyStatistics/CustomClassifyStatistics.vue')
export default {
  path: '/main/wechatMgmt/customClassifyStatistics',
  name: 'CustomClassifyStatistics',
  component: CustomClassifyStatistics
}
